export enum ContextualComponentMode {
  USER,
  DEPARTMENT,
}
